import { debounce } from "lodash";
import ReactGA from "react-ga4";

const init = (options: any = {}) => {
  if (window.location.href.includes("localhost")) {
    return;
  }
  // The GA account id is rewritten in the shippable CI depending on
  // which branch is being built.
  ReactGA.initialize("UA-91596213-3", {
    // Debug is switched to false when building the master branch
    debug: false,
    ...options,
  });

  // Set additional custom dimension as we can do things in GA with
  // custom dimensions that we can't do with the user_id. Use the
  // field dimension1 as that is what is mapped in GA. This name can't
  // be more descriptive, that is how GA works (as far as I can tell).
  if (options && options.gaOptions && options.gaOptions.userId) {
    ReactGA.set({ dimension1: options.gaOptions.userId });
  }

  // Send initial page view
  sendPageView();

  // Set up observer for title changes
  observeTitle();

  return true;
};

const GA = {
  init,
  sendPageView,
};

export default GA;

function sendPageView() {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: document.title,
  });
}

function observeTitle() {
  const titleElement = document.querySelector("title");
  if (titleElement) {
    const observer = new MutationObserver(
      debounce(() => {
        sendPageView();
      }, 500) // limit pageview events to once every 500ms
    );
    observer.observe(titleElement, { childList: true });
  }
}
